import { Autocomplete, Field, Filter, Button, SearchField, DateRange } from "components/commons";
import React from "react";
import styles from "./pay-history-filter.module.scss";
import locale from "localization";
import { SelectStation } from "components/field";
import { prettifyProductType } from "utils/pretty.utils";
import { Products } from "enums";
import { sortProductsBySku } from "utils/object.utils";

const PayHistoryFilter = ({
  filterState,
  applyFilter,
  applyClearFilter,
  applyResetFilter,
  modifyFilter,
  modifySearch,
  applySearch,
  applyClearSearch,
  searchKey,
  filterCount,
  exportReport,
  exporting,
  resetFilter,
  getUserAccess,
  modifyForm,
}) => {
  const { productCodes, referenceStation } = filterState;

  return (
    <div className={styles.container}>
      <div className={styles.filter}>
        <Filter
          filterCount={filterCount}
          submit={applyFilter}
          close={resetFilter}
          clear={applyClearFilter}
        >
          <div
            style={{
              padding: "0px 20px",
            }}
          >
            <Field
              className={styles.date}
              label={locale.dateOfTransaction}
              labelPosition={"left"}
              childrenClassName={styles.fieldContent}
            >
              <DateRange
                placeholder="Set Date"
                value={{
                  startDate: filterState.startDate,
                  endDate: filterState.endDate,
                }}
                onChange={(_, { value }) => {
                  const { startDate, endDate } = value;
                  modifyFilter({
                    startDate: startDate,
                    endDate: endDate,
                  });
                }}
              />
              {/* <DatePickerV2
                value={filterState.startDate}
                placeholder="Set Date"
                onChange={(_, { value }) => {
                  modifyFilter({
                    startDate: moment(value)
                      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                      .toDate(),
                    endDate: moment(value)
                      .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
                      .toDate(),
                  });
                }}
              /> */}
            </Field>
            <Field
              label={`SEAOIL ${locale.station}`}
              labelPosition={"left"}
              className={styles.filterInput}
              childrenClassName={styles.fieldContent}
            >
              <SelectStation
                {...referenceStation}
                isMultiple
                disableAllOption
                isPlbOnboarded
                allLabel={locale.station}
                allSelectedText={locale.allStations}
                selectAllLabel={locale.allStations}
                onChange={(_, { value, isAll }) => {
                  modifyFilter({ referenceStation: { value, isAll } });
                }}
              />
            </Field>
            <Field
              label={locale.productType}
              labelPosition={"left"}
              className={styles.filterInput}
              childrenClassName={styles.fieldContent}
            >
              <Autocomplete
                name="productCodes"
                value={productCodes}
                options={sortProductsBySku(Object.values(Products).map((sku) => ({ sku })))
                  .map(({ sku }) => sku)
                  .map((type) => ({
                    label: prettifyProductType(type),
                    value: type,
                  }))}
                onChange={(name, { value }) => {
                  modifyFilter({
                    [name]: value,
                  });
                }}
              />
            </Field>
          </div>
        </Filter>
        <Field className={styles.search}>
          <SearchField
            placeholder={[
              locale.mobileNumber,
              locale.vipCardNumber,
              locale.vipTransactionId,
              locale.orNumber,
            ].join(", ")}
            value={searchKey}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onClear={applyClearSearch}
            onEnter={applySearch}
            restrict={false}
          />
        </Field>
        <Field className={styles.downloadButton}>
          {(getUserAccess?.fullAccess || getUserAccess?.exportAccess) && (
            <Button
              startIcon={<span className="icon-download" />}
              exportButton
              onClick={exportReport}
              loading={exporting}
            >
              {locale.export}
            </Button>
          )}
        </Field>
      </div>
    </div>
  );
};

export default PayHistoryFilter;
